import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getTenant = async (tenantId) => {
  return base.get({
    url: API_PARAM.TENANTS_GET,
    params: { id: tenantId },
  });
};

export const addTenant = async (data) => {
  return base.post({
    url: `${API_PARAM.TENANTS}`,
    data,
    nonceHeader: true,
  });
};

export const editTenant = async (id, data) => {
  return base.patch({
    url: API_PARAM.TENANTS,
    data: { ...data, id },
  });
};

export const deleteTenant = async (data) => {
  return base.deleteRequest({
    url: API_PARAM.TENANTS,
    data,
  });
};

export const restoreTenant = async (data) => {
  return base.patch({
    url: API_PARAM.TENANT_RESTORE,
    data,
  });
};

export const getTenantConfigDetails = (id) => {
  return base.get({
    url: API_PARAM.TENANT_CONFIGURATION.replace("{tenantId}", id),
  });
};

export const syncTenantSkills = (id) => {
  return base.post({
    url: API_PARAM.SYNC_TENANT_SKILLS,
    params: { tenantId: id },
  });
};